import { AppDispatch } from '@/main'
import { useDispatch } from 'react-redux'

export const useStoreDispatch = () => useDispatch<AppDispatch>()
